import script from "./RemoveBackground.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveBackground.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveBackground.scss?vue&type=style&index=0&id=e417309a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e417309a"]])

export default __exports__